import { Injectable } from '@angular/core';
import { ComponentBase } from '../../../component-base';
import { IMouseRelease, IMouseDown, IMouseMove, IDoubleClick } from '../Interfaces';
import { DrawingsHolderService } from '../drawings-holder.service';
import { PositionCalculatorService } from '../position-calculator.service';
import { Rectangle } from '../object3D';
import { SelectComponent } from '.';

declare let THREE: any;

@Injectable()
export class DrawRectangleComponent extends ComponentBase implements IMouseDown, IMouseMove, IMouseRelease, IDoubleClick {
  added: boolean = false;
  size: number;
  dblclick(e: MouseEvent): boolean {

    this.rectangle = undefined;
    this.selectComponent.enable();
    this.selectComponent.mouseUp(e);
    this.disable();
    return true;
  }

  private static readonly right = new THREE.Vector3(1, 0, 0);
  private static readonly bottom = new THREE.Vector3(0, 0, 1);
  private rectangle: Rectangle | undefined;
  private firstPoint;

  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private selectComponent: SelectComponent
  ) {
    super();
    this.disable();
  }

  mouseDown(e: MouseEvent): boolean {
    // const point = this.positionCalculator.calculate(e);
    // const rectangle = new Rectangle();
    // rectangle.position.copy(point);
    // this.rectangle = rectangle;
    // this.rectangle.changeOrigin();
    // this.firstPoint = point;
    return true;
  }

  mouseMove(e: MouseEvent): boolean {
    if (this.firstPoint) {
      const point = this.positionCalculator.calculate(e);
      if (this.firstPoint.distanceTo(point) > 4) {
        const diff = point.sub(this.firstPoint);
        const xDirection = diff.clone().multiply(DrawRectangleComponent.right).normalize();
        const yDirection = diff.clone().multiply(DrawRectangleComponent.bottom).normalize();
        const width = diff.clone().projectOnVector(DrawRectangleComponent.right).length() * Math.sign(xDirection.x);
        const height = diff.clone().projectOnVector(DrawRectangleComponent.bottom).length() * Math.sign(yDirection.z);
        const size = Math.max(Math.abs(width), Math.abs(height));
        this.size = size;
        if (width !== 0 && height !== 0) {
          this.rectangle.update(size * Math.sign(xDirection.x), size * Math.sign(yDirection.z));
        }
        if (this.added) {

        } else {
          this.added = true;
          this.drawings.canvas.add(this.rectangle);
        }
      }
      return true;
    }
    return false;
  }

  mouseUp(e: MouseEvent): boolean {
    if (this.firstPoint) {
      this.rectangle.restoreOrigin();
      // const point = this.positionCalculator.calculate(e);
      // const direction = point.sub(this.firstPoint);
      // const directionToCenter = new THREE.Vector3(
      //   direction.x / Math.abs(direction.x),
      //   0,
      //   direction.z / Math.abs(direction.z)
      // )
      //   .multiplyScalar(this.size / 2);
      // this.rectangle.updatePosition(directionToCenter);

      this.added = false;
      this.firstPoint = null;
      return false;
    } else if (this.rectangle) {
      this.rectangle = null;
    } else {
      const point = this.positionCalculator.calculate(e);
      const rectangle = new Rectangle();
      rectangle.position.copy(point);
      this.rectangle = rectangle;
      this.rectangle.changeOrigin();
      this.firstPoint = point;
      return true;
    }
    // return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/DrawRectangleComponent.ts